import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=11186cd4"
import script from "./Arrow.vue?vue&type=script&lang=js"
export * from "./Arrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/vue-treeselect/vue-treeselect/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11186cd4')) {
      api.createRecord('11186cd4', component.options)
    } else {
      api.reload('11186cd4', component.options)
    }
    module.hot.accept("./Arrow.vue?vue&type=template&id=11186cd4", function () {
      api.rerender('11186cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/Arrow.vue"
export default component.exports